<template>
<div class="server-config-wrap">
  <div class="tab-bar">
    <button
      v-for="tab in tabList"
      :key="tab.key"
      class="tab-btn"
      :class="{active: currentTab === tab.key}"
      @click="handleTabChange(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>
  <div v-if="currentTab === 'base'" class="base-config-panel">
    <div class="btn-top-group">
      <button class="btn-get" @click="getServerInfo">获取信息</button>
      <button class="btn-save" @click="saveBaseToString">保存基础配置</button>
    </div>

    <div class="tip-row">
      <span class="tip-desc">🔵左侧为服务器原始数据(只读)｜🟢右侧为待修改值，保存才生效</span>
    </div>

    <div class="config-row-group">
      <div class="config-block">
        <div class="double-item">
          <input type="checkbox" :checked="serverReadData.kickSpeedUp" disabled />
          <label>踢加速(服务器)</label>
          <input type="checkbox" v-model="editData.kickSpeedUp" />
          <label>踢加速(修改)</label>
        </div>
        <div class="double-item">
          <input type="checkbox" :checked="serverReadData.closeSpeedUp" disabled />
          <label>关加速(服务器)</label>
          <input type="checkbox" v-model="editData.closeSpeedUp" />
          <label>关加速(修改)</label>
        </div>
        <div class="num-triple">
          <div class="num-double">
            <input type="number" :value="serverReadData.num179" disabled />
            <input type="number" v-model.number="editData.num179" />
          </div>
          <div class="num-double">
            <input type="number" :value="serverReadData.num320" disabled />
            <input type="number" v-model.number="editData.num320" />
          </div>
          <div class="num-double">
            <input type="number" :value="serverReadData.num490" disabled />
            <input type="number" v-model.number="editData.num490" />
          </div>
        </div>
        <div class="double-item">
          <input type="checkbox" :checked="serverReadData.kickBot" disabled />
          <label>踢外挂(服务器)</label>
          <input type="checkbox" v-model="editData.kickBot" />
          <label>踢外挂(修改)</label>
        </div>
      </div>

      <div class="config-block">
        <div class="double-text-item">
          <span>连接：</span>
          <input v-model="serverReadData.connText" disabled />
        </div>
        <div class="double-text-item">
          <span>用户：</span>
          <input v-model="serverReadData.userText" disabled />
        </div>
        <div class="double-text-item">
          <span>MAX：</span>
          <input type="number" v-model.number="serverReadData.maxNum" disabled />
        </div>
        <div class="double-text-item">
          <span>P：</span>
          <input v-model="serverReadData.pText" disabled />
        </div>
        <div class="double-text-item">
          <span>在线用户users：</span>
          <input type="number" v-model.number="serverReadData.users" disabled />
        </div>
        <div class="double-text-item">
          <span>连接数conns：</span>
          <input type="number" v-model.number="serverReadData.conns" disabled />
        </div>
        <div class="double-text-item">
          <span>场景worlds：</span>
          <input type="number" v-model.number="serverReadData.worlds" disabled />
        </div>
        <div class="double-text-item">
          <span>asof：</span>
          <input type="number" v-model.number="serverReadData.asof" disabled />
        </div>
      </div>

      <div class="config-block">
        <h4>用户限制</h4>
        <div class="double-num-line">
          <label>用户ID</label>
          <input type="number" :value="serverReadData.limitUid" disabled />
          <input type="number" v-model.number="editData.limitUid" />
        </div>
        <div class="double-num-line">
          <label>外网IP</label>
          <input type="number" :value="serverReadData.limitIp" disabled />
          <input type="number" v-model.number="editData.limitIp" />
        </div>
        <div class="double-num-line">
          <label>机器码</label>
          <input type="number" :value="serverReadData.limitMachine" disabled />
          <input type="number" v-model.number="editData.limitMachine" />
        </div>
        <div class="double-num-line">
          <label>顶号时限</label>
          <input type="number" :value="serverReadData.limitKickTime" disabled />
          <input type="number" v-model.number="editData.limitKickTime" />
        </div>
      </div>
    </div>

    <div class="config-row-group">
      <div class="config-block vertical-num">
        <div class="double-num-line">
          <label>其他</label>
          <input type="number" :value="serverReadData.otherVal" disabled />
          <input type="number" v-model.number="editData.otherVal" />
        </div>
        <div class="double-num-line">
          <label>角色</label>
          <input type="number" :value="serverReadData.roleVal" disabled />
          <input type="number" v-model.number="editData.roleVal" />
        </div>
        <div class="double-num-line">
          <label>移动</label>
          <input type="number" :value="serverReadData.moveVal" disabled />
          <input type="number" v-model.number="editData.moveVal" />
        </div>
        <div class="double-num-line">
          <label>技能MAX</label>
          <input type="number" :value="serverReadData.skillMaxVal" disabled />
          <input type="number" v-model.number="editData.skillMaxVal" />
        </div>
        <div class="double-num-line">
          <label>浩然</label>
          <input type="number" :value="serverReadData.haoranVal" disabled />
          <input type="number" v-model.number="editData.haoranVal" />
        </div>
      </div>
      <div class="config-block four-col">
        <div class="double-num-line">
          <label>经验翻倍</label>
          <input type="number" :value="serverReadData.expRate" disabled />
          <input type="number" v-model.number="editData.expRate" />
        </div>
        <div class="double-num-line">
          <label>攻击</label>
          <input type="number" :value="serverReadData.atkRate" disabled />
          <input type="number" v-model.number="editData.atkRate" />
        </div>
        <div class="double-num-line">
          <label>心法</label>
          <input type="number" :value="serverReadData.heartRate" disabled />
          <input type="number" v-model.number="editData.heartRate" />
        </div>
        <div class="double-num-line">
          <label>步法</label>
          <input type="number" :value="serverReadData.stepRate" disabled />
          <input type="number" v-model.number="editData.stepRate" />
        </div>
      </div>
      <div class="config-block four-col">
        <div class="double-num-line">
          <label>护体</label>
          <input type="number" :value="serverReadData.bodyRate" disabled />
          <input type="number" v-model.number="editData.bodyRate" />
        </div>
        <div class="double-num-line">
          <label>辅助</label>
          <input type="number" :value="serverReadData.auxRate" disabled />
          <input type="number" v-model.number="editData.auxRate" />
        </div>
        <div class="double-num-line">
          <label>技能</label>
          <input type="number" :value="serverReadData.skillRate" disabled />
          <input type="number" v-model.number="editData.skillRate" />
        </div>
        <div class="double-num-line">
          <label>年龄</label>
          <input type="number" :value="serverReadData.ageRate" disabled />
          <input type="number" v-model.number="editData.ageRate" />
        </div>
      </div>
    </div>

    <div class="bottom-check-group">
      <div class="double-item">
        <input type="checkbox" :checked="serverReadData.hideMemBot" disabled />
        <label>屏蔽内存挂(服务器)</label>
        <input type="checkbox" v-model="editData.hideMemBot" />
        <label>屏蔽内存挂(修改)</label>
      </div>
      <div class="double-item">
        <input type="checkbox" :checked="serverReadData.optimizeCrowd" disabled />
        <label>挤号优化(服务器)</label>
        <input type="checkbox" v-model="editData.optimizeCrowd" />
        <label>挤号优化(修改)</label>
      </div>
      <div class="double-item">
        <input type="checkbox" :checked="serverReadData.optimizeMoveErr" disabled />
        <label>优化移动错屏(服务器)</label>
        <input type="checkbox" v-model="editData.optimizeMoveErr" />
        <label>优化移动错屏(修改)</label>
      </div>
    </div>

    <div class="res-show" v-if="resText">{{ resText }}</div>
  </div>

  <div v-if="currentTab === 'online'" class="online-panel">
    <div class="online-top-bar">
      <div class="search-row">
        <span>查找对象</span>
        <select v-model="onlineFilterType">
          <option value="ALL">ALL</option>
          <option value="登陆ID">登陆ID</option>
          <option value="角色名称">角色名称</option>
          <option value="连线IP">连线IP</option>
          <option value="外网IP">外网IP</option>
          <option value="上线时间">上线时间</option>
          <option value="机器码">机器码</option>
        </select>
        <input v-model="onlineKeyword" placeholder="输入关键字" />
        <button class="search-btn" @click="searchOnlineUser">查询</button>
        <div class="stat-text-group" v-if="onlineUserList.length > 0">
          <span>玩家数量：{{ onlineStat.playerCount }}</span>
          <span>IP数量：{{ onlineStat.ipCount }}</span>
          <span>机器数量：{{ onlineStat.machineCount }}</span>
        </div>
      </div>
      <div class="btn-row">
        <button @click="refreshOnlineList">刷新全部在线</button>
        <button @click="forceOffline">强制下线</button>
        <button @click="banLoginId">屏蔽登陆ID</button>
        <button @click="banIp">屏蔽IP</button>
        <button @click="banMachineCode">屏蔽机器码</button>
        <button @click="goBanList">屏蔽列表</button>
        <button class="btn-merge" @click="mergeServer">合区</button>
      </div>
    </div>
    <table class="online-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>登陆ID</th>
          <th>角色名称</th>
          <th>连线IP</th>
          <th>外网IP</th>
          <th>上线时间</th>
          <th>机器码</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in onlineUserList" :key="idx" @click="selectOnlineRow(idx)" :class="{active: selectedOnlineIdx === idx}">
          <td>{{ idx + 1 }}</td>
          <td>{{ item.loginId }}</td>
          <td>{{ item.roleName }}</td>
          <td>{{ item.linkIp }}</td>
          <td>{{ item.outIp }}</td>
          <td>{{ item.onlineTime }}</td>
          <td>{{ item.machineCode }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="currentTab === 'ban'" class="ban-panel">
    <div class="ban-op-row">
      <button @click="refreshBanList">刷新屏蔽列表</button>
      <select v-model="banAddType">
        <option value="登陆ID">屏蔽登陆ID</option>
        <option value="IP">屏蔽IP</option>
        <option value="机器码">屏蔽机器码</option>
      </select>
      <input v-model="banAddContent" placeholder="输入屏蔽内容" />
      <button @click="addBanItem">添加</button>
      <button @click="delBanItem">删除选中屏蔽</button>
    </div>
    <table class="ban-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>屏蔽项目</th>
          <th>屏蔽内容</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in banList" :key="idx" @click="selectBanRow(idx)" :class="{active: selectedBanIdx === idx}">
          <td>{{ idx + 1 }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.content }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="currentTab === 'drop'" class="drop-panel">
    <div class="drop-top-bar">
      <div class="input-line">
        <label>当前值</label>
        <input type="number" v-model.number="dropEdit.cur" />
      </div>
      <div class="input-line">
        <label>爆出值</label>
        <input type="number" v-model.number="dropEdit.drop" />
      </div>
      <div class="input-line">
        <label>设定值</label>
        <input type="number" v-model.number="dropEdit.set" />
      </div>
      <button @click="modifyDropRate">修改预览</button>
      <button @click="refreshDropList">刷新爆率列表</button>
      <button class="btn-save-all" @click="saveCurrentDrop">保存当前爆率</button>
    </div>
    <div class="table-scroll-wrap" style="max-height:500px;overflow:auto;border:1px solid #999;">
      <table class="drop-table">
        <thead style="position:sticky;top:0;background:#409eff;">
          <tr>
            <th>序号</th>
            <th>物品名称</th>
            <th>怪物名称</th>
            <th>当前值</th>
            <th>爆出值</th>
            <th>设定值</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in dropList" :key="idx" @click="selectRow(idx)" :class="{active:selectedRowIndex === idx}">
            <td>{{ idx + 1 }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.monsterName }}</td>
            <td>{{ item.cur }}</td>
            <td>{{ item.drop }}</td>
            <td>{{ item.set }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="res-show" v-if="dropOutputStr">{{ dropOutputStr }}</div>
  </div>
</div>
</template>

<script setup>
const props = defineProps(['serverName'])
import { reactive, ref, watch, onMounted } from 'vue'
import { showToast } from '@/utils/toast'
const baseUrl = "https://log.wuxiahaojie.com/api/FUWUQI"

const filterOptionList = [
  "ALL",
  "登陆ID",
  "角色名称",
  "连线IP",
  "外网IP",
  "上线时间",
  "机器码"
]
const tabList = [
  { key: 'base', label: '基础信息' },
  { key: 'online', label: '用户在线信息' },
  { key: 'ban', label: '用户屏蔽信息' },
  { key: 'drop', label: '野怪爆率信息' }
]
const currentTab = ref('base')
const resText = ref('')

function handleTabChange(key) {
  currentTab.value = key
  if (key === "drop") {
    refreshDropList()
  }
}

// serverReadData：服务器原始返回，只读展示
const serverReadData = reactive({
  kickSpeedUp: false,
  closeSpeedUp: false,
  num179: 0,
  num320: 0,
  num490: 0,
  kickBot: false,
  connText: "",
  userText: "",
  maxNum: 0,
  pText: "",
  limitUid: 0,
  limitIp: 0,
  limitMachine: 0,
  limitKickTime: 0,
  otherVal: 0,
  roleVal: 0,
  moveVal: 0,
  skillMaxVal: 0,
  haoranVal: 0,
  expRate: 0,
  atkRate: 0,
  heartRate: 0,
  stepRate: 0,
  bodyRate: 0,
  auxRate: 0,
  skillRate: 0,
  ageRate: 0,
  hideMemBot: false,
  optimizeCrowd: false,
  optimizeMoveErr: false,
  users: 0,
  conns: 0,
  worlds: 0,
  asof: 0
})

// editData 用户编辑修改的数据
const editData = reactive({
  kickSpeedUp: false,
  closeSpeedUp: false,
  num179: 0,
  num320: 0,
  num490: 0,
  kickBot: false,
  connText: "",
  userText: "",
  maxNum: 0,
  pText: "",
  limitUid: 0,
  limitIp: 0,
  limitMachine: 0,
  limitKickTime: 0,
  otherVal: 0,
  roleVal: 0,
  moveVal: 0,
  skillMaxVal: 0,
  haoranVal: 0,
  expRate: 0,
  atkRate: 0,
  heartRate: 0,
  stepRate: 0,
  bodyRate: 0,
  auxRate: 0,
  skillRate: 0,
  ageRate: 0,
  hideMemBot: false,
  optimizeCrowd: false,
  optimizeMoveErr: false,
  users: 0,
  conns: 0,
  worlds: 0,
  asof: 0
})

// 拷贝服务器数据到编辑对象
function copyReadToEdit() {
  Object.assign(editData, serverReadData)
}

const parseBool = (v) => String(v).toLowerCase() === 'true'

function parseStrFillForm(str) {
  const arr = str.split(',')
  serverReadData.kickSpeedUp = parseBool(arr[0])
  serverReadData.closeSpeedUp = parseBool(arr[1])
  serverReadData.num179 = Number(arr[2])
  serverReadData.num320 = Number(arr[3])
  serverReadData.num490 = Number(arr[4])
  serverReadData.kickBot = parseBool(arr[5])
  serverReadData.connText = arr[6]
  serverReadData.userText = arr[7]
  serverReadData.maxNum = Number(arr[8])
  serverReadData.pText = arr[9]
  serverReadData.limitUid = Number(arr[10])
  serverReadData.limitIp = Number(arr[11])
  serverReadData.limitMachine = Number(arr[12])
  serverReadData.limitKickTime = Number(arr[13])
  serverReadData.otherVal = Number(arr[14])
  serverReadData.roleVal = Number(arr[15])
  serverReadData.moveVal = Number(arr[16])
  serverReadData.skillMaxVal = Number(arr[17])
  serverReadData.haoranVal = Number(arr[18])
  serverReadData.expRate = Number(arr[19])
  serverReadData.atkRate = Number(arr[20])
  serverReadData.heartRate = Number(arr[21])
  serverReadData.stepRate = Number(arr[22])
  serverReadData.bodyRate = Number(arr[23])
  serverReadData.auxRate = Number(arr[24])
  serverReadData.skillRate = Number(arr[25])
  serverReadData.ageRate = Number(arr[26])
  serverReadData.hideMemBot = parseBool(arr[27])
  serverReadData.optimizeCrowd = parseBool(arr[28])
  serverReadData.optimizeMoveErr = parseBool(arr[29])
}

function getBaseInfo() {
  const xhr = new XMLHttpRequest()
  xhr.open("GET", `${baseUrl}/worldgetbase?servername=${props.serverName}`, false)
  xhr.send()
  if (xhr.status === 200) {
    const raw = xhr.responseText
    try {
      const json = JSON.parse(raw)
      resText.value = "获取基础配置返回：" + raw
      parseStrFillForm(json.data)
      serverReadData.users = json.users ?? 0
      serverReadData.conns = json.conns ?? 0
      serverReadData.worlds = json.worlds ?? 0
      serverReadData.asof = json.asof ?? 0
      // 获取完服务器数据，同步到编辑框
      copyReadToEdit()
    } catch (e) {
      resText.value = "JSON解析失败：" + e.message + " 原始数据:" + raw
    }
  } else {
    resText.value = "获取基础配置异常：" + xhr.statusText
  }
}

// 序列化使用editData（用户修改的数据）
function getBaseSubmitString() {
  const arr = [
    String(editData.kickSpeedUp),
    String(editData.closeSpeedUp),
    editData.num179,
    editData.num320,
    editData.num490,
    String(editData.kickBot),
    editData.connText,
    editData.userText,
    editData.maxNum,
    editData.pText,
    editData.limitUid,
    editData.limitIp,
    editData.limitMachine,
    editData.limitKickTime,
    editData.otherVal,
    editData.roleVal,
    editData.moveVal,
    editData.skillMaxVal,
    editData.haoranVal,
    editData.expRate,
    editData.atkRate,
    editData.heartRate,
    editData.stepRate,
    editData.bodyRate,
    editData.auxRate,
    editData.skillRate,
    editData.ageRate,
    String(editData.hideMemBot),
    String(editData.optimizeCrowd),
    String(editData.optimizeMoveErr)
  ]
  return arr.join(',')
}

function saveBaseToString() {
  const s = getBaseSubmitString()
  const url = `${baseUrl}/worldsave?servername=${props.serverName}&data=${encodeURIComponent(s)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "保存基础配置成功：" + xhr.responseText
    // ✅保存成功，自动重新拉服务器最新数据刷新只读区域
    getBaseInfo()
  } else {
    resText.value = "保存基础配置异常：" + xhr.statusText
  }
}

function getServerInfo() {
  getBaseInfo()
}

onMounted(function() {
  //getBaseInfo()
  //refreshDropList()
})

// --------下面在线、屏蔽、爆率模块代码完全原样保留，没有改动--------
const onlineFilterType = ref("ALL")
const onlineKeyword = ref("")
const onlineStat = reactive({
  playerCount: 0,
  ipCount: 0,
  machineCount: 0
})
const onlineUserList = ref([])
const selectedOnlineIdx = ref(-1)
function selectOnlineRow(idx) {
  selectedOnlineIdx.value = idx
}
watch(onlineUserList, function(list) {
  onlineStat.playerCount = list.length
  const ips = new Set()
  const machines = new Set()
  for (let i = 0; i < list.length; i++) {
    ips.add(list[i].linkIp)
    machines.add(list[i].machineCode)
  }
  onlineStat.ipCount = ips.size
  onlineStat.machineCount = machines.size
}, { immediate: true })
function checkSelectedOnline() {
  if (selectedOnlineIdx.value < 0) {
    alert("请先点击选择一条在线用户数据！")
    return false
  }
  return true
}
function searchOnlineUser() {
  const index = filterOptionList.findIndex(item => item === onlineFilterType.value)
  const keyword = onlineKeyword.value.trim()
  const xhr = new XMLHttpRequest()
  const url = `${baseUrl}/getworlduser?servername=${props.serverName}&index=${index}&name=${encodeURIComponent(keyword)}`
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    const raw = xhr.responseText
    const list = []
    if (raw !== "") {
      const arr = raw.split(',')
      for (let i = 0; i < arr.length; i += 6) {
        list.push({
          loginId: arr[i],
          roleName: arr[i+1],
          linkIp: arr[i+2],
          outIp: arr[i+3],
          onlineTime: arr[i+4],
          machineCode: arr[i+5]
        })
      }
    }
    onlineUserList.value = list
    selectedOnlineIdx.value = -1
    resText.value = `条件查询完成，筛选到${list.length}条在线用户`
  } else {
    resText.value = "条件查询在线用户失败：" + xhr.statusText
    onlineUserList.value = []
    selectedOnlineIdx.value = -1
  }
}
function refreshOnlineList() {
  const xhr = new XMLHttpRequest()
  xhr.open("GET", `${baseUrl}/worldgetalluser?servername=${props.serverName}`, false)
  xhr.send()
  if (xhr.status === 200) {
    const raw = xhr.responseText
    const list = []
    if (raw !== "") {
      const arr = raw.split(',')
      for (let i = 0; i < arr.length; i += 6) {
        list.push({
          loginId: arr[i],
          roleName: arr[i+1],
          linkIp: arr[i+2],
          outIp: arr[i+3],
          onlineTime: arr[i+4],
          machineCode: arr[i+5]
        })
      }
    }
    onlineUserList.value = list
    selectedOnlineIdx.value = -1
    resText.value = "在线用户刷新成功"
  } else {
    resText.value = "获取在线用户失败：" + xhr.statusText
    onlineUserList.value = []
    selectedOnlineIdx.value = -1
  }
}
function forceOffline() {
  if (!checkSelectedOnline()) return
  const row = onlineUserList.value[selectedOnlineIdx.value]
  const url = `${baseUrl}/worldclose?servername=${props.serverName}&data=${encodeURIComponent(row.roleName)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "强制下线【" + row.roleName + "】返回：" + xhr.responseText
    refreshOnlineList()
  } else {
    resText.value = "踢人下线异常：" + xhr.statusText
  }
}
function banLoginId() {
  if (!checkSelectedOnline()) return
  const row = onlineUserList.value[selectedOnlineIdx.value]
  const send =  row.loginId+",0"
  const url = `${baseUrl}/ban?servername=${props.serverName}&data=${encodeURIComponent(send)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "屏蔽登录ID【" + row.loginId + "】返回：" + xhr.responseText
    refreshBanList()
  } else {
    resText.value = "屏蔽登录ID异常：" + xhr.statusText
  }
}
function banIp() {
  if (!checkSelectedOnline()) return
  const row = onlineUserList.value[selectedOnlineIdx.value]
  const send =  row.linkIp+",1"
  const url = `${baseUrl}/ban?servername=${props.serverName}&data=${encodeURIComponent(send)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "屏蔽IP【" + row.linkIp + "】返回：" + xhr.responseText
    refreshBanList()
  } else {
    resText.value = "屏蔽IP异常：" + xhr.statusText
  }
}
function banMachineCode() {
  if (!checkSelectedOnline()) return
  const row = onlineUserList.value[selectedOnlineIdx.value]
  const send = row.machineCode+",2"
  const url = `${baseUrl}/ban?servername=${props.serverName}&data=${encodeURIComponent(send)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "屏蔽机器码【" + row.machineCode + "】返回：" + xhr.responseText
    refreshBanList()
  } else {
    resText.value = "屏蔽机器码异常：" + xhr.statusText
  }
}
function goBanList() {
  currentTab.value = "ban"
  refreshBanList()
}
function mergeServer() {
  const key = onlineKeyword.value.trim()
  if (!key) {
    resText.value = "请在上方输入框填写合区关键字"
    return
  }
  const url = `${baseUrl}/worldheqv?servername=${props.serverName}&data=${encodeURIComponent(key)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "合区操作返回：" + xhr.responseText
  } else {
    resText.value = "合区异常：" + xhr.statusText
  }
}
const banAddType = ref("登陆ID")
const banAddContent = ref("")
const banList = ref([])
const selectedBanIdx = ref(-1)
function selectBanRow(idx) {
  selectedBanIdx.value = idx
}
function refreshBanList() {
  const xhr = new XMLHttpRequest()
  xhr.open("GET", `${baseUrl}/getban?servername=${props.serverName}`, false)
  xhr.send()
  if (xhr.status === 200) {
    const raw = xhr.responseText
    const arr = raw.split(',')
    const list = []
    for (let i = 0; i < arr.length; i += 2) {
      list.push({
        type: arr[i],
        content: arr[i+1]
      })
    }
    banList.value = list
    selectedBanIdx.value = -1
    resText.value = "屏蔽列表刷新完成"
  } else {
    resText.value = "获取屏蔽列表失败：" + xhr.statusText
    banList.value = []
  }
}
function addBanItem() {
  const content = banAddContent.value.trim()
  if (!content) {
    resText.value = "请输入屏蔽内容"
    return
  }
  let typeStr = ""
  if (banAddType.value === "登陆ID") typeStr = "0"
  if (banAddType.value === "IP") typeStr = "1"
  if (banAddType.value === "机器码") typeStr = "2"
  const send = content  + "," + typeStr
  const url = `${baseUrl}/ban?servername=${props.serverName}&data=${encodeURIComponent(send)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "新增屏蔽返回：" + xhr.responseText
    banAddContent.value = ''
    refreshBanList()
  } else {
    resText.value = "新增屏蔽异常：" + xhr.statusText
  }
}
function delBanItem() {
  if (selectedBanIdx.value < 0) {
    resText.value = "请先点击选择一条屏蔽数据"
    return
  }
  const item = banList.value[selectedBanIdx.value]
  const url = `${baseUrl}/deleteban?servername=${props.serverName}&data=${encodeURIComponent(item.content)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "删除屏蔽【" + item.content + "】返回：" + xhr.responseText
    refreshBanList()
  } else {
    resText.value = "删除屏蔽异常：" + xhr.statusText
  }
}
const dropList = ref([])
const selectedRowIndex = ref(-1)
const dropEdit = reactive({
  cur: 0,
  drop: 0,
  set: 0
})
const dropOutputStr = ref("")
function safeNum(val) {
  const n = Number(val)
  return isNaN(n) ? 0 : n
}
function refreshDropList() {
  const xhr = new XMLHttpRequest()
  xhr.open("GET", `${baseUrl}/getbao?servername=${props.serverName}`, false)
  xhr.send()
  if (xhr.status === 200) {
    const raw = xhr.responseText
    const arr = raw.split(',')
    const list = []
    for (let i = 0; i < arr.length; i += 5) {
      const itemName = arr[i] || ""
      const monsterName = arr[i+1] || ""
      const cur = safeNum(arr[i+2])
      const drop = safeNum(arr[i+3])
      const set = safeNum(arr[i+4])
      list.push({
        itemName: itemName.trim(),
        monsterName: monsterName.trim(),
        cur,
        drop,
        set
      })
    }
    dropList.value = list
    selectedRowIndex.value = -1
    dropOutputStr.value = ""
    resText.value = "野怪爆列表刷新成功"
  } else {
    resText.value = "获取爆率数据失败：" + xhr.statusText
    dropList.value = []
  }
}
function selectRow(idx) {
  selectedRowIndex.value = idx
  const row = dropList.value[idx]
  dropEdit.cur = row.cur
  dropEdit.drop = row.drop
  dropEdit.set = row.set
}
function modifyDropRate() {
  if (selectedRowIndex.value < 0) {
    resText.value = "请先点击选择一行爆率数据"
    return
  }
  resText.value = "输入框已修改，点击保存当前爆率才会覆盖表格数据并提交"
}
function saveCurrentDrop() {
  if (selectedRowIndex.value < 0) {
    resText.value = "请先选择一条爆率数据再保存"
    return
  }
  const targetRow = dropList.value[selectedRowIndex.value]
  targetRow.cur = safeNum(dropEdit.cur)
  targetRow.drop = safeNum(dropEdit.drop)
  targetRow.set = safeNum(dropEdit.set)
  const sendArr = [
    targetRow.itemName,
    targetRow.monsterName,
    targetRow.cur,
    targetRow.drop,
    targetRow.set
  ]
  const sendStr = sendArr.join(',')
  dropOutputStr.value = sendStr
  const url = `${baseUrl}/xgbao?servername=${props.serverName}&data=${encodeURIComponent(sendStr)}`
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false)
  xhr.send()
  if (xhr.status === 200) {
    resText.value = "当前爆率保存成功：" + xhr.responseText
  } else {
    resText.value = "保存爆率异常：" + xhr.statusText
  }
}
</script>

<style scoped>
.server-config-wrap {
  padding: 12px;
}
.tab-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
.tab-btn {
  padding: 6px 14px;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.tab-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}
.btn-top-group, .ban-op-row, .drop-top-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.online-top-bar {
  margin-bottom: 12px;
}
.online-top-bar .search-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding: 8px;
  background: #f7f8fa;
  border-radius: 6px;
}
.online-top-bar .stat-text-group {
  display: flex;
  gap: 18px;
  margin-left: 10px;
}
.online-top-bar .btn-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.search-btn {
  background: #409eff;
  color: white;
  border: none;
  padding: 4px 14px;
  border-radius: 4px;
  cursor: pointer;
}
.config-row-group {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.config-block {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
}

.tip-row {
  margin-bottom:8px;
  color:#666;
}

.double-item {
  display:flex;
  align-items:center;
  gap:8px;
  margin:6px 0;
}
.double-num-line {
  display:flex;
  align-items:center;
  gap:6px;
  margin:6px 0;
}
.double-text-item {
  display:flex;
  align-items:center;
  gap:6px;
  margin:6px 0;
}
.num-triple {
  display: flex;
  gap: 6px;
}
.num-double {
  display:flex;
  gap:4px;
}

input[disabled] {
  background:#f0f2f5;
  color:#666;
}

input[type="number"], input[type="text"], select {
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: center;
}
tr.active {
  background: #e6f2ff;
}
.res-show {
  padding: 8px;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  margin-top:10px;
}
</style>
